// Custom components
import Text from "components/Text";
import React from "react";

import { getInputSize } from "../utils";

const InputText = (props) => {
    const { label, id, extra, type, placeholder, size = 'md', rounded = false, state, disabled, errors, ...rest } = props;
    const roundedSize = size === 'sm' || size === 'xs' ? 'rounded-lg' : 'rounded-xl'

    return (
        <div className={`${extra} flex flex-col gap-1`}>
            {label && (
                <Text variant="linkBold" content={label} />
            )}
            
            <input
                disabled={disabled}
                type={type}
                id={id}
                placeholder={placeholder}
                className={`flex ${rounded ? 'rounded-full' : roundedSize} ${getInputSize(size)} w-full items-center justify-center rounded-xl border bg-white/0 outline-none ${
                disabled === true
                    ? "!border-none !bg-gray-100 dark:!bg-white/5 dark:placeholder:!text-[rgba(255,255,255,0.15)]"
                    : state === "error"
                    ? "border-red-500 text-red-500 placeholder:text-red-500 dark:!border-red-400 dark:!text-red-400 dark:placeholder:!text-red-400"
                    : state === "success"
                    ? "border-green-500 text-green-500 placeholder:text-green-500 dark:!border-green-400 dark:!text-green-400 dark:placeholder:!text-green-400"
                    : "border-gray-200 dark:!border-white/10 dark:text-white"
                }`}
                {...rest}
            />
            {errors?.show && <span className="text-[#DF2A36] text-[12px]">{errors.message}</span>}
        </div>
    );
}

export default InputText;
